import * as React from 'react';
import { Answer } from './Answer';
import YouTube from 'react-youtube';

export const Question = (props) => {

    const [selectedAnswer,setSelectedAnswer] = React.useState(-1);
    const [answerCorrectly, setAnswerCorrectly] = React.useState(null);

    const onSelectAnswer = ( answerIdx, isCorrect ) => {

        props.registerResult ( props.idx, isCorrect );

        setSelectedAnswer(answerIdx);
        setAnswerCorrectly(isCorrect);

    }

    const youTubeGetID = (url) => {
        var ID = '';
        url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        if(url[2] !== undefined) {
            ID = url[2].split(/[^0-9a-z_\-]/i);
            ID = ID[0];
        }
        else {
            ID = url;
        }
        return ID;
    }


    if ( ! props.visible ) return <></>;

    let questionClass = ["question"];
    if(!props.isCurrentquestion || ( props.isCurrentquestion && props.checkAnswer ) ) questionClass.push("completed");

    let counterClass = ["counter"];
    if(answerCorrectly !== null&& ( !props.isCurrentquestion || ( props.isCurrentquestion && props.checkAnswer ) ) ) counterClass.push(answerCorrectly?"correct":"incorrect");

    let mediaClass = ["media"];
    if("image" in props.data && props.data.image.length >1) mediaClass.push("multiple");

    return (
        <div className={questionClass.join(" ")}>
            <div className="content">
                <div className={counterClass.join(" ")}>
                    { props.idx+1 }/{ props.questionCount }
                </div>
                <div className="title" dangerouslySetInnerHTML={{__html: props.data.title}} />
                <ul className="answers">
                    {props.data.answer.map((answer,answer_idx) => <li key={`${props.idx}_${answer_idx}`}>
                        <Answer
                            data={answer}
                            idx={answer_idx}
                            question_idx={props.idx}
                            onAnswerQuestion={props.onAnswerQuestion}
                            hasAnswered={props.hasAnswered}
                            checkAnswer={props.checkAnswer}
                            gaveThisAnswer={selectedAnswer===answer_idx}
                            onSelectAnswer={onSelectAnswer}
                            isCurrentquestion={props.isCurrentquestion}
                        />
                    </li>)}
                </ul>
                { answerCorrectly !== null&& ( !props.isCurrentquestion || ( props.isCurrentquestion && props.checkAnswer ) )  ? <div className="feedback" dangerouslySetInnerHTML={{__html: props.data.feedback}} /> : "" }
            </div>
            <div className={mediaClass.join(" ")}>
                { "image" in props.data && props.data.image.map ((image,image_idx) => <div className="image" key={`img_${props.idx}_${image_idx}`} style={ {backgroundImage : `url(${image.uri})`}}  ><img src={image.uri} title={image.title} alt={image.alt} /></div>)}
                { "video" in props.data && props.data.video.map ((video,video_idx) => <div className="video" key={`video_${props.idx}_${video_idx}`}>
                    <YouTube
                        videoId={youTubeGetID(video)}
                        opts={{
                            width: '100%'
                        }}
                    />
                </div>)}
            </div>
        </div>
    );
}
